import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthStore } from '../stores';
import { ApplicationFile } from '../models';
import { Role } from '../enums';

@Injectable({ providedIn: 'root' })
export class ApplicationFileService {
  private readonly httpClient = inject(HttpClient);
  private readonly authStore = inject(AuthStore);
  $user = this.authStore.user;

  uploadPartnerLogo(partnerId: string | undefined, file: File): Observable<ApplicationFile> {
    const formData: FormData = new FormData();
    formData.set('file', file);
    return this.httpClient
      .post<any>(`/api/partners/${partnerId || 'me'}/logo`, formData)
      .pipe(map((applicationFile) => ApplicationFile.mapFromApiValue(applicationFile)));
  }

  downloadPartnerLogo(partnerId?: string): Observable<string> {
    const apiUrl =
      this.$user()?.role === Role.User ? '/api/customers/me/partner/logo' : `/api/partners/${partnerId || 'me'}/logo`;

    return this.httpClient
      .get(apiUrl, { responseType: 'blob' })
      .pipe(map((blob: Blob) => (blob.size ? window.URL.createObjectURL(blob) : '')));
  }
}
